var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('Error'):_c('div',[_c(_vm.initComponent,{tag:"component",attrs:{"idExercice":_vm.idExercice,"idFormation":_vm.idFormation}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }